module.exports = __webpack_public_path__ + "img/cover-4.ff36dc7f.jpg";